import { render, staticRenderFns } from "./BlockForm.vue?vue&type=template&id=1ebceaca"
import script from "./BlockForm.vue?vue&type=script&lang=js"
export * from "./BlockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports